class LocalTransform {
  constructor({
    width,
    height
  }, outerDimensions = {
    width,
    height
  }) {
    const scale = Math.min(outerDimensions.width / width, outerDimensions.height / height);
    const dx = -(0.5 * width - 0.5) * scale + 0.5 * outerDimensions.width - 0.5;
    const dy = -(0.5 * height - 0.5) * scale + 0.5 * outerDimensions.height - 0.5;
    this.scale = scale;
    this.dx = dx;
    this.dy = dy;
    this.width = (outerDimensions.width - dx * 2) / scale;
    this.height = (outerDimensions.height - dy * 2) / scale;
  }

  unscale(value) {
    return value / this.scale;
  }

  getPointFromEvent(nativeEvent) {
    const {
      dx,
      dy,
      scale
    } = this;
    const {
      offsetX,
      offsetY
    } = nativeEvent;
    const x = (offsetX - dx) / scale;
    const y = (offsetY - dy) / scale;
    return [x, y];
  }

}

export default LocalTransform;